// 获取当前时间

export function getDateTime() {
  const now = new Date();
  const year = now.getFullYear(); // 得到年份
  const month = now.getMonth() + 1; // 得到月份
  const date = now.getDate(); // 得到日期
  // var day = now.getDay();//得到周几
  const hour = now.getHours(); // 得到小时数
  const minute = now.getMinutes(); // 得到分钟数
  // var second = now.getSeconds(); //得到秒数
  // "2019-11-12 18:30" year  + month + date + hour + minute
  return `${year}-${month}-${date} ${hour}:${minute} `;
}

/**
 * 格式化时间显示，补零对齐
 * eg：2:4  -->  02:04
 * @param {string} value - 形如 h:m:s 的字符串
 */
function formatTime(value) {
  let time = "";
  const s = value.split(":");
  let i = 0;
  for (; i < s.length - 1; i++) {
    time += s[i].length === 1 ? "0" + s[i] : s[i];
    time += ":";
  }
  time += s[i].length === 1 ? "0" + s[i] : s[i];
  return time;
}

/**
 * 音频播放时间换算
 * @param {number} value - 音频当前播放时间，单位秒
 */
export function transTime(value) {
  let time = "";
  const h = parseInt(value / 3600);
  value %= 3600;
  const m = parseInt(value / 60);
  const s = parseInt(value % 60);
  if (h > 0) {
    time = formatTime(h + ":" + m + ":" + s);
  } else {
    time = formatTime(m + ":" + s);
  }
  return time;
}

/*
* 获取当天的日期, 返回 "2022.09.23" 格式
* */
export function getCurrentDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}.${month}.${day}`;
}

/*
* 传入一个 字符串 日期 比如 "2023.05.12" 返回 未来或者过去 4周的星期一
* 会返回当周的, 所以当周的要删除掉
* @param {String } dateStr 字符串
* @param {Boolean } isFuture true表示未来, false表示过去
* */
export function getFiveWeeksMondays(dateStr, isFuture = true) {
  const date = new Date(dateStr);
  // 获取到当前日期所在周的周一
  const mondayOfCurrentWeek = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1));
  const result = [];
  for (let i = 0; i < 10; i++) {
    // 计算未来第 i 周的周一日期
    let mondayOfNextWeek;
    if (isFuture) {
      mondayOfNextWeek = new Date(mondayOfCurrentWeek.getTime() + 7 * 24 * 60 * 60 * 1000 * i);
    } else {
      mondayOfNextWeek = new Date(mondayOfCurrentWeek.getTime() - 7 * 24 * 60 * 60 * 1000 * i);
    }
    result.push(`${mondayOfNextWeek.getFullYear()}.${(mondayOfNextWeek.getMonth() + 1).toString().padStart(2, "0")}.${mondayOfNextWeek.getDate().toString().padStart(2, "0")}`);
  }
  return result;
}

/*
* 根据传入的时间, 自动返回从周一开始的日期, 周一到周日的日期
* 例如传入 "2023.05.15"，函数会返回 "2023.05.09-05.15"；传入 "2023.05.16"，也会返回 "2023.05.09-05.15"。
* @param {String} dateStr 日期 如 "2023.05.15" 的字符
* */
export function getNextWeekTime(dateStr) {
  if (!dateStr) {
    dateStr = getCurrentDate();
  }
  const dateArr = dateStr.split(".");
  const year = parseInt(dateArr[0]);
  let yearFlag = false; // 记录是否需要加上年份
  let month = parseInt(dateArr[1]) - 1;
  const dayOfWeek = new Date(year, month, dateArr[2]).getDay();
  const startDate = new Date(year, month, dateArr[2] - (dayOfWeek + 6) % 7);
  const endDate = new Date(startDate.getTime() + 6 * 24 * 60 * 60 * 1000);
  let endYear = year;
  if (endDate.getFullYear() !== year) { // 跨年
    month = endDate.getMonth() + 1;
    endYear = endDate.getFullYear();
    yearFlag = true;
  } else if (endDate.getMonth() !== startDate.getMonth()) { // 跨月
    month = endDate.getMonth() + 1;
  } else {
    month += 1;
    // console.log(month);
  }
  const startMonth = startDate.getMonth() + 1 < 10 ? `0${startDate.getMonth() + 1}` : startDate.getMonth() + 1;
  const startDate0 = startDate.getDate() < 10 ? `0${startDate.getDate()}` : startDate.getDate();
  const endMonth = month < 10 ? `0${month}` : month;
  const endDay = endDate.getDate() < 10 ? `0${endDate.getDate()}` : endDate.getDate();
  return `${startDate.getFullYear()}.${startMonth}.${startDate0}-${yearFlag ? endYear + "." : ""}${endMonth}.${endDay}`;
}
